import React from "react";
import FlightFormSearchTOF from "./Flight-Form-Search-TOF";

class FlightHomeTop extends React.Component {
  render() {
    return (
      <div className="page-container">
        <div className="padideh-home-top">
          <FlightFormSearchTOF domesticFlight={this.props.domesticFlight}  onSearchRepeate={this.props.onSearchRepeate}/>
          <div
            onClick={() => this.props.handleLink()}
            className="adv-banner hidden-small hidden-xsmall hidden-medium margin-start-medium"
          ></div>
        </div>
      </div>
    );
  }
}
export default FlightHomeTop;
